module.exports = __webpack_public_path__ + "src/assets/games/42/160.jpg";